import { PlotDetailPage } from '@/components/plots/plot-detail-page'

export function OperationsPlotDetail() {
  return (
    <PlotDetailPage
      plotsBasePath="/operations/plots"
      membersBasePath="/operations/members"
      canManage
    />
  )
}
